module.exports = __webpack_public_path__ + "img/train-wheels-shadow-2.af879d8f.png";